/**
 * A telephone number as people write it: "+49 4642 965959", "0172/1234567",
 * "+41 (0)71 123 45 67". react-admin's number() accepted only what parses as a
 * number, so a leading + or a space made the customer form refuse to save.
 */
export const phone = () => (value?: string | null) =>
  value && !/^\+?[0-9][0-9 ()/.-]*[0-9]$/.test(value.trim()) ? 'validation.phone' : undefined
